import { FrenchFlag } from "./FrenchFlag";
import { useLang } from "../i18n";

const Row = ({ items }) => (
    <div className="flex shrink-0 items-center">
        {items.map((item, i) => (
            <span key={i} className="flex items-center">
                <span className="font-serif italic text-2xl sm:text-3xl text-charcoal/80 px-10 sm:px-14 whitespace-nowrap flex items-center gap-3">
                    {item}
                    {(item === "Formulated in France" || item === "Formulé en France" || item === "صُيغ في فرنسا") && (
                        <FrenchFlag className="w-5 h-3.5" />
                    )}
                </span>
                <span className="text-gold text-lg">✦</span>
            </span>
        ))}
    </div>
);

export const Marquee = () => {
    const { t } = useLang();
    const items = t("marquee");
    return (
        <div className="relative py-8 border-y border-gold/25 bg-cream overflow-hidden" data-testid="editorial-marquee">
            <div className="flex w-max animate-marquee">
                <Row items={items} />
                <Row items={items} />
            </div>
        </div>
    );
};
